.UnitHealthBar {
  overflow: hidden;
  background-color: #f0ead6;
  position: relative;
  border-width: 0.05em;
  border-color: #111111;
  border-style: solid;
}
.UnitHealthBar .Fill {
  width: 0%;
  height: 100%;
  z-index: 10;
  position: absolute;
  background-color: #d54b33;
  transition-property: width;
  transition-duration: 0.1s;
}
.UnitHealthBar .Fill[isBig] {
  background-color: #862b1c;
}
.UnitHealthBar .OmegaFill {
  width: 0%;
  height: 100%;
  z-index: 20;
  position: absolute;
  background-color: #f0ead6;
  animation-iteration-count: infinite;
}
.UnitHealthBar .OmegaFill[color=heal] {
  animation-duration: 1s;
  animation-name: pulse-white;
}
@keyframes pulse-white {
  0% {
    background-color: #f0ead6;
  }
  25% {
    background-color: #f0ead6;
  }
  50% {
    background-color: #d54b33;
  }
  75% {
    background-color: #f0ead6;
  }
  100% {
    background-color: #f0ead6;
  }
}
.UnitHealthBar .OmegaFill[color=hurt] {
  animation-duration: 2s;
  animation-name: pulse-red;
}
@keyframes pulse-red {
  0% {
    background-color: #d54b33;
  }
  25% {
    background-color: #d54b33;
  }
  50% {
    background-color: #f0ead6;
  }
  75% {
    background-color: #d54b33;
  }
  100% {
    background-color: #d54b33;
  }
}
.UnitHealthBar .Borders {
  top: 0em;
  left: 0em;
  bottom: 0em;
  right: 0em;
  z-index: 30;
  max-width: 100%;
  position: absolute;
  display: flex;
}
.UnitHealthBar .Borders .Border {
  flex: 1;
}
.UnitHealthBar .Borders .Border:not(:last-child) {
  border-right-width: 0.05em;
  border-right-style: solid;
  border-right-color: #111111;
}
